export const BenefitType = {
    SOCIAL_SECURITY_BENEFIT : 'Social Security Benefits',
    ANNUAL_BENEFIT: 'Annual Benefits'
};